import {
  Box,
  Breadcrumbs,
  CircularProgress,
  Grid,
  Pagination,
  PaginationItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Colors from "../../components/constants/Colors";
import {
  Add,
  ArrowBack,
  DynamicFeed,
  FolderCopy,
  NavigateNext,
  PostAdd,
} from "@mui/icons-material";
import { FilterContasAPagarLanc } from "../../components/filter/FilterContasAPagarLanc";
import CustomDatagrid from "../../components/datagrid/CustomDatagrid";
import LiquidacaoModal from "../../components/modals/LiquidacaoModal";
import { usePaginationQuery } from "../../helpers/pagination";
import axios from "axios";
import { headers } from "../../components/core/store/localStorage";
import errorHandler from "../../components/core/store/errorHandler";
import ErrorModal from "../../components/modals/ErrorModal";
import { ConfirmModal } from "../../components/modals/ConfirmModal";
import { parseBRLToNumber } from "../../components/tables/ParcelasTable";
import { formatNumber, formatValor } from "../../helpers/formaters";
import FormasPagamentoTable from "../../components/tables/FormasPagamentoTable";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

export const ContasAPagarLancamento = () => {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 13,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "10px",
      textAlign: "left",
      "&::placeholder": {
        fontSize: "10px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  const location = useLocation();
  const navigate = useNavigate();

  const { setQueryParams } = usePaginationQuery();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const page = Number(query.get("page") || 1);
  const filter = query.get("filtro");
  const isMobile = useMediaQuery("(max-width: 375px)");

  const [head, setHead] = useState([]);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({});
  const [totalPages, setTotalPages] = useState(0);

  const [isSearch, setIsSearch] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [titleLoading, setTitleLoading] = useState("Carregando...");
  const [showGrid, setShowGrid] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isMultiLanc, setIsMultiLanc] = useState(false);
  const [fornecedor, setFornecedor] = useState("");
  const [fornecedorList, setFornecedorList] = useState([]);
  const [tipoDoc, setTipoDoc] = useState("");
  const [tipoDocList, setTipoDocList] = useState([]);
  const [estabelecimento, setEstabelecimento] = useState("");
  const [estabelecimentoList, setEstabelecimentoList] = useState([]);
  const [situacao, setSituacao] = useState("");
  const [situacaoId, setSituacaoId] = useState("");
  const [numTitulo, setNumTitulo] = useState("");
  const [parcela, setParcela] = useState("");
  const [numDoc, setNumDoc] = useState("");
  const [agenteCobrador, setAgenteCobrador] = useState("");
  const [agenteCobradorList, setAgenteCobradorList] = useState([]);
  const [centroCusto, setCentroCusto] = useState("");
  const [centroCustoList, setCentroCustoList] = useState([]);
  const [despesa, setDespesa] = useState("");
  const [despesaList, setDespesaList] = useState([]);
  const [contaContabil, setContaContabil] = useState("");
  const [planoContasList, setPlanoContasList] = useState([]);
  const [breveDescricao, setBreveDescricao] = useState("");
  const [historico, setHistorico] = useState("");
  const [dataEmissao, setDataEmissao] = useState("");
  const [dataVencto, setDataVencto] = useState("");
  const [dataPrevisao, setDataPrevisao] = useState("");
  const [atraso, setAtraso] = useState("");
  const [isVencido, setIsVencido] = useState(false);
  const [data, setData] = useState("");
  const [competencia, setCompetencia] = useState("");
  const [valorPagamento, setValorPagamento] = useState("");
  const [valorValores, setValorValores] = useState("");
  const [valorJurosDia, setValorJurosDia] = useState("");
  const [multa, setMulta] = useState("");
  const [acerto, setAcerto] = useState("");
  const [valorCorrigido, setValorCorrigido] = useState("");
  const [valorMulti, setValorMulti] = useState("");
  const [antecipaFeriado, setAntecipaFeriado] = useState(false);
  const [antecipaFimSemana, setAntecipaFimSemana] = useState(false);
  const [emissao, setEmissao] = useState("");
  const [venctoInicial, setVenctoInicial] = useState("");
  const [prazo, setPrazo] = useState("");
  const [diaEspecifico, setDiaEspecifico] = useState("");
  const [tipoFormaPagamento, setTipoFormaPagamento] = useState("");
  const [tipoFormaPagamentoList, setTipoFormaPagamentoList] = useState([]);
  const [descricao, setDescricao] = useState("");
  const [dataConciliacao, setDataConciliacao] = useState("");
  const [valorFormaPagamento, setValorFormaPagamento] = useState("");
  const [banco, setBanco] = useState("");
  const [bancosList, setBancosList] = useState([]);
  const [agencia, setAgencia] = useState("");
  const [agenciasList, setAgenciasList] = useState([]);
  const [conta, setConta] = useState("");
  const [contasList, setContasList] = useState([]);
  const [numCheque, setNumCheque] = useState("");
  const [tipoTit, setTipoTit] = useState("");
  const [tipoTitList, setTipoTitList] = useState([]);
  const [parcelasGeradas, setParcelasGeradas] = useState([]);
  const [isEstornado, setIsEstornado] = useState(false);
  const [isLiquidado, setIsLiquidado] = useState(false);
  const [openLiquidacao, setOpenLiquidacao] = useState(false);
  const [contaCorrenteList, setContaCorrenteList] = useState([]);
  const [id, setId] = useState("");
  const [dataInicio, setDataInicio] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
  });
  const [dataFim, setDataFim] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  });
  const [hasSearched, setHasSearched] = useState(false);
  const [openPayloadModal, setOpenPayloadModal] = useState(false);
  const [payloadErrors, setPayloadErrors] = useState([]);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openBackModal, setOpenBackModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [openConfirmEstorno, setOpenConfirmEstorno] = useState(false);
  const [situacaoAberto, setSituacaoAberto] = useState(false);
  const [situacaoPago, setSituacaoPago] = useState(false);
  const [situacaoCancelado, setSituacaoCancelado] = useState(false);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [inativo, setInativo] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [messageModal, setMessageModal] = useState("");
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const situacaoPorId = {
    1: "Pago",
    2: "A Pagar",
    3: "Atrasado",
    4: "Cancelado",
  };

  // useEffect(() => {
  //   console.log(situacaoId);
  // }, [situacaoId]);

  useEffect(() => {
    if (API_URL === null) window.location.href = "/";
    getFornecedor();
    getTipoDoc();
    getEstabelecimento();
    getAgenteCobrador();
    getCentroCusto();
    getDespesa();
    getPlanoContas();
    getContaCorrente();
    getTipoPag();
  }, []);

  useEffect(() => {
    if (!hasSearched) return;
    fetchContasAPagar(page, filter);
  }, [page, filter, hasSearched]);

  const getFornecedor = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/fornecedor/combo`,
        headers(),
      );

      setFornecedorList(response.data.fornecedor);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const fornecedorListAtivos = useMemo(
    () => (fornecedorList || []).filter((item) => item.inativo === false),
    [fornecedorList],
  );

  const getTipoDoc = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/tipodocumento/combo`,
        headers(),
      );

      setTipoDocList(response.data.tipodocumento);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const tipoDocListAtivos = useMemo(
    () => (tipoDocList || []).filter((item) => item.inativo === false),
    [tipoDocList],
  );

  const getEstabelecimento = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/estabelecimento/combo`,
        headers(),
      );

      setEstabelecimentoList(response.data.estabelecimento);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const estabelecimentoListAtivos = useMemo(
    () => (estabelecimentoList || []).filter((item) => item.inativo === false),
    [estabelecimentoList],
  );

  const getAgenteCobrador = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/agentecobrador/combo`,
        headers(),
      );

      setAgenteCobradorList(response.data.agentecobrador);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const agenteCobradorListAtivos = useMemo(
    () => (agenteCobradorList || []).filter((item) => item.inativo === false),
    [agenteCobradorList],
  );

  const getCentroCusto = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo`,
        headers(),
      );

      setCentroCustoList(response.data.centrocusto);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const centroCustoListAtivos = useMemo(
    () => (centroCustoList || []).filter((item) => item.inativo === false),
    [centroCustoList],
  );

  const getDespesa = async () => {
    try {
      const response = await axios.get(`${API_URL}/despesa/combo`, headers());

      setDespesaList(response.data.despesa);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const despesaListAtivos = useMemo(
    () => (despesaList || []).filter((item) => item.inativo === false),
    [despesaList],
  );

  const getPlanoContas = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/planocontas/combo`,
        headers(),
      );

      setPlanoContasList(response.data.planocontas);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const planoContasListAtivos = useMemo(
    () => (planoContasList || []).filter((item) => item.inativo === false),
    [planoContasList],
  );

  const getContaCorrente = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/contacorrente/combo`,
        headers(),
      );

      setContaCorrenteList(response.data.contacorrente);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const contaCorrenteListAtivos = useMemo(
    () => (contaCorrenteList || []).filter((item) => item.inativo === false),
    [contaCorrenteList],
  );

  const getTipoPag = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/tipopagamento/combo`,
        headers(),
      );

      setTipoFormaPagamentoList(response.data.tipopagamento);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const tipoFormaPagamentoListAtivos = useMemo(
    () =>
      (tipoFormaPagamentoList || []).filter((item) => item.inativo === false),
    [tipoFormaPagamentoList],
  );

  const searchContasAPagar = () => {
    setHasSearched(true);

    const qp = { page: 1 };

    if (searchValue?.trim()) qp.filtro = searchValue.trim();
    if (dataInicio?.trim()) qp.dataInicio = dataInicio.trim();
    if (dataFim?.trim()) qp.dataFim = dataFim.trim();
    // if (isLiquidado !== undefined) qp.liquidado = String(isLiquidado);

    if (situacaoAberto && !situacaoPago && !situacaoCancelado) {
      qp.situacao = "1";
    } else if (!situacaoAberto && situacaoPago && !situacaoCancelado) {
      qp.situacao = "2";
    } else if (!situacaoAberto && !situacaoPago && situacaoCancelado) {
      qp.situacao = "3";
    } else {
      qp.situacao = "";
    }

    setQueryParams(qp, false);
    fetchContasAPagar(1);
  };

  const fetchContasAPagar = async (pageToFetch) => {
    setLoading(true);
    setShowGrid(false);
    setNotFound(false);

    try {
      const params = new URLSearchParams();
      params.set("page", String(pageToFetch));

      if (searchValue?.trim()) params.set("filtro", searchValue.trim());
      if (dataInicio?.trim()) params.set("dataInicio", dataInicio.trim());
      if (dataFim?.trim()) params.set("dataFim", dataFim.trim());
      // params.set("liquidado", String(isLiquidado));
      const situacoesSelecionadas = [];
      if (situacaoAberto) situacoesSelecionadas.push("1");
      if (situacaoPago) situacoesSelecionadas.push("2");
      if (situacaoCancelado) situacoesSelecionadas.push("3");
      if (situacoesSelecionadas.length > 0) {
        params.set("situacao", situacoesSelecionadas.join(","));
      } else {
        params.delete("situacao");
      }
      const url = `${API_URL}/contasapagar?${params.toString()}`;

      const response = await axios.get(url, headers());

      const payload = response?.data || {};
      const data = payload.data || [];
      const pages = Number(payload.totalPages || 1);

      setTotalPages(pages);

      if (pageToFetch > pages) {
        setQueryParams({ page: pages }, true);
        return;
      }

      if (data.length === 0) {
        setNotFound(true);
        setShowGrid(false);
        if (pageToFetch > 1) setQueryParams({ page: 1 }, true);
        return;
      }

      setShowGrid(true);
      setHead(payload.columns || []);
      setRows(data);
      setTotals(payload.totalizador || {});
      setNotFound(false);
    } catch (error) {
      setShowGrid(false);
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const diffDias = (dateStrYYYYMMDD) => {
    if (!dateStrYYYYMMDD) return 0;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const [y, m, d] = dateStrYYYYMMDD.split("-").map(Number);
    const dataRef = new Date(y, m - 1, d);
    dataRef.setHours(0, 0, 0, 0);

    const ms = hoje.getTime() - dataRef.getTime();
    const dias = Math.floor(ms / (1000 * 60 * 60 * 24));

    return Math.max(0, dias);
  };

  const handleEdit = (row) => {
    // console.log(row);
    const c = row?.content || {};

    const formasTratadas = (c.formasPagamento || []).map((fp) => ({
      ...fp,
      id: fp.id,
      banco: fp.bancoId,
      agencia: fp.agenciaId,
      conta: fp.contaId,
      nroCheque: fp.numCheque,
    }));

    setInativo(row.inativo === "Cancelado" ? true : false);
    setFormasPagamento(formasTratadas);
    // setDataInicio("");
    // setDataFim("");
    setIsEditing(true);
    setIsSearch(false);
    setShowGrid(false);
    const liquidado = !!c.liquidado;
    const dataReferencia = c.dataVencto || c.dataPrevisao;
    let diasEmAtraso = 0;
    aplicarAtrasoSeHouver({ ...c, liquidado: !!c.liquidado });
    const vOriginal = parseBRLToNumber(c.valorValores);
    const jurosDiario = parseBRLToNumber(c.valorJurosDia);
    const percMulta = parseBRLToNumber(c.multa);
    const vAcerto = parseBRLToNumber(c.acerto);

    let totalCalculado = vOriginal;

    if (diasEmAtraso > 0) {
      const totalJuros = jurosDiario * diasEmAtraso;
      const totalMulta = vOriginal * (percMulta / 100);
      totalCalculado = vOriginal + totalJuros + totalMulta + vAcerto;
    } else {
      totalCalculado = vOriginal + vAcerto;
    }
    const situacaoIdNum = Number(c.situacaoId);
    const situacaoTexto =
      situacaoPorId[situacaoIdNum] || (c.liquidado ? "Pago" : "A Pagar");

    setId(c.id);
    setIsLiquidado(liquidado);
    setSituacao(situacaoTexto);
    // console.log(c.situacaoId);
    setSituacaoId(c.situacaoId);
    setFornecedor(c.fornecedorId);
    setTipoDoc(c.tipoDocId);
    setEstabelecimento(c.estabelecimentoId);
    setAgenteCobrador(c.agenteCobradorId);
    setCentroCusto(c.centroCustoId);
    setDespesa(c.despesaId);
    setContaContabil(c.contaContabilId);
    setNumDoc(c.numDoc);
    setNumTitulo(c.numTitulo);
    setParcela(c.parcela);
    setDataEmissao(c.dataEmissao);
    setDataPrevisao(c.dataPrevisao);
    setDataVencto(c.dataVencto);
    setData(c.data);
    setCompetencia(c.competencia);
    setDataConciliacao(c.dataConciliacao);
    setBreveDescricao(c.breveDescricao);
    setHistorico(c.historico);
    setDescricao(c.descricao);
    setValorValores(c.valorValores || "R$ 0,00");
    setValorJurosDia(c.valorJurosDia || "");
    setMulta(c.multa || "");
    setAcerto(c.acerto || "");
    setValorPagamento(c.valorPagamento || "");
    setValorCorrigido(c.valorCorrigido || "");
    setTipoFormaPagamento(c.tipoFormaPagamento);
    setValorFormaPagamento(c.valorFormaPagamento);
    setBanco(c.banco);
    setAgencia(c.agencia);
    setConta(c.conta);
    setNumCheque(c.numCheque);
    setTipoTit(c.tipoTit);
    setEmissao(c.emissao);
  };

  const handleClone = (row) => {
    // console.log(row);
    const c = row?.content || {};
    setSituacaoId("");
    setSituacao("A Pagar");
    const hoje = new Date();
    const yyyy = hoje.getFullYear();
    const mm = String(hoje.getMonth() + 1).padStart(2, "0");
    const dd = String(hoje.getDate()).padStart(2, "0");

    setInativo(false);
    setIsEditing(false);
    setDataEmissao(`${yyyy}-${mm}-${dd}`);
    setCompetencia(c.competencia);
    setLoading(false);
    setNotFound(false);
    setShowGrid(false);
    setIsSearch(false);
    setIsMultiLanc(false);
    setId("");
    setFornecedor(c.fornecedorId);
    setTipoDoc(c.tipoDocId);
    setEstabelecimento(c.estabelecimentoId);
    setAgenteCobrador(c.agenteCobradorId);
    setCentroCusto(c.centroCustoId);
    setDespesa(c.despesaId);
    setContaContabil(c.contaContabilId);
    setNumDoc(c.numDoc);
    setParcela("");
    setBreveDescricao(c.breveDescricao);
    setHistorico(c.historico);
    setDescricao(c.descricao);
    setValorValores(c.valorValores || "R$ 0,00");
    setValorJurosDia(c.valorJurosDia || "");
    setMulta(c.multa || "");
    setAcerto(c.acerto || "");
    setValorPagamento(c.valorPagamento || "");
    setValorCorrigido(c.valorCorrigido || "");
    setTipoFormaPagamento(c.tipoFormaPagamento);
    setValorFormaPagamento(c.valorFormaPagamento);
    setBanco(c.banco);
    setAgencia(c.agencia);
    setConta(c.conta);
    setNumCheque(c.numCheque);
    setTipoTit(c.tipoTit);
    setEmissao(c.emissao);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setOpenMessageModal(true);

    const pergunta =
      row.inativo === "Cancelado"
        ? "Deseja realmente ativar este lançamento?"
        : "Deseja realmente cancelar este lançamento?";

    setMessageModal(pergunta);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    setShowGrid(false);

    const estaCancelado = selectedRow.content.situacaoId === "4";

    const novaSituacaoId = estaCancelado ? "2" : "4";
    const novaSituacao = estaCancelado ? "A Pagar" : "Cancelado";
    const novoStatusInativo = !estaCancelado;

    const payload = {
      ...selectedRow.content,
      id: selectedRow.content.id,
      situacao: novaSituacao,
      situacaoId: novaSituacaoId,
      inativo: novoStatusInativo,
      liquidado: false,
    };

    // console.log(payload);

    try {
      await axios.post(`${API_URL}/contasapagar`, payload, headers());

      fetchContasAPagar(page);

      setSituacaoId(novaSituacaoId);
    } catch (err) {
      errorHandler(err);
      if (err.response?.data?.message) {
        setPayloadErrors([err.response.data.message]);
        setOpenPayloadModal(true);
      }
    } finally {
      setLoading(false);
      setShowGrid(true);
      setOpenMessageModal(false);
    }
  };

  async function gerarParcelas(qtdRaw) {
    if (prazo && Number(prazo) < 1) {
      setPayloadErrors(["Prazo deve ser maior que zero."]);
      setOpenPayloadModal(true);
      return;
    }

    if (diaEspecifico && Number(diaEspecifico) < 1) {
      setPayloadErrors(["Dia específico deve ser maior que zero."]);
      setOpenPayloadModal(true);
      return;
    }

    if (Number(qtdRaw) < 1) {
      setPayloadErrors(["Quantidade de parcelas deve ser maior que zero."]);
      setOpenPayloadModal(true);
      return;
    }

    const qtd = Number(qtdRaw) || 0;

    if (!qtd || !venctoInicial) {
      console.warn("Campos insuficientes para gerar parcelas.");
      return;
    }

    const toYYYYMMDD = (dt) => {
      const yyyy = dt.getFullYear();
      const mm = String(dt.getMonth() + 1).padStart(2, "0");
      const dd = String(dt.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const parseYYYYMMDD = (s) => {
      const [y, m, d] = String(s).split("-").map(Number);
      return new Date(y, m - 1, d);
    };

    const daysInMonth = (year, monthIndex0) =>
      new Date(year, monthIndex0 + 1, 0).getDate();

    const aplicarDiaEspecifico = (dt, dia) => {
      const day = Math.max(1, Math.min(31, Number(dia)));
      const last = daysInMonth(dt.getFullYear(), dt.getMonth());
      dt.setDate(Math.min(day, last));
      return dt;
    };

    const isWeekend = (dt) => {
      const dow = dt.getDay();
      return dow === 0 || dow === 6;
    };

    const feriadosCache = new Map();

    async function ensureFeriadosAno(ano) {
      if (feriadosCache.has(ano)) return feriadosCache.get(ano);

      try {
        const resp = await fetch(
          `https://brasilapi.com.br/api/feriados/v1/${ano}`,
        );
        if (!resp.ok) throw new Error(`Falha ao buscar feriados (${ano})`);

        const lista = await resp.json();
        const set = new Set((lista || []).map((f) => f.date));

        feriadosCache.set(ano, set);
        return set;
      } catch (e) {
        console.error(e);
        return new Set();
      }
    }

    const baseDate = parseYYYYMMDD(venctoInicial);
    if (!isNaN(baseDate.getTime()) && antecipaFeriado) {
      let startYear = baseDate.getFullYear();
      let endYear = startYear;
      const prazoDias = Number(prazo || 0);

      if (prazoDias > 0) {
        const totalDays = prazoDias * qtd;
        endYear = startYear + Math.ceil(totalDays / 365);
      } else {
        endYear = startYear + Math.ceil(qtd / 12);
      }

      const promises = [];
      for (let y = startYear; y <= endYear + 1; y++) {
        promises.push(ensureFeriadosAno(y));
      }
      await Promise.all(promises);
    }

    const isFeriadoSync = (yyyyMmDd) => {
      if (!yyyyMmDd) return false;
      const ano = Number(String(yyyyMmDd).slice(0, 4));
      // Se nao tiver no cache, eh porque falhou ou nao deu tempo, entao assume false
      // Mas como fizemos await Promise.all, deve estar la se o fetch funcinou
      const feriadosSet = feriadosCache.get(ano);
      return feriadosSet ? feriadosSet.has(yyyyMmDd) : false;
    };

    const isDiaNaoUtilSync = (dt) => {
      const ymd = toYYYYMMDD(dt);

      if (antecipaFimSemana && isWeekend(dt)) return true;
      if (antecipaFeriado && isFeriadoSync(ymd)) return true;

      return false;
    };

    const ajustarParaDiaUtilAnteriorSync = (dt) => {
      let guard = 0;

      while (isDiaNaoUtilSync(dt) && guard < 40) {
        dt.setDate(dt.getDate() - 1);
        guard++;
      }

      return dt;
    };

    try {
      const base = parseYYYYMMDD(venctoInicial);
      if (isNaN(base.getTime())) throw new Error("Data inválida");

      const prazoDias = Number(prazo || 0);
      const diaFix = Number(diaEspecifico || 0);

      const rows = Array.from({ length: qtd }, (_, i) => {
        let dt = new Date(base.getTime());

        const diaDesejado = base.getDate();

        if (diaFix > 0 && diaFix < diaDesejado) {
          if (i === 0) {
            dt = new Date();
          } else {
            dt = new Date();
            dt.setDate(1);
            dt.setMonth(dt.getMonth() + i);
            dt = aplicarDiaEspecifico(dt, diaFix);
          }
        } else {
          if (prazoDias > 0) {
            dt.setDate(dt.getDate() + i * prazoDias);
          } else {
            dt.setMonth(dt.getMonth() + i, 1);

            const ultimoDiaDoMesAlvo = daysInMonth(
              dt.getFullYear(),
              dt.getMonth(),
            );
            dt.setDate(Math.min(diaDesejado, ultimoDiaDoMesAlvo));
          }

          if (diaFix > 0) {
            dt = aplicarDiaEspecifico(dt, diaFix);
          }
        }

        dt = ajustarParaDiaUtilAnteriorSync(dt);

        return {
          id: i + 1,
          emissao: emissao,
          vencimento: toYYYYMMDD(dt),
          parcela: i + 1,
          valor: valorMulti,
        };
      });

      setParcelasGeradas(rows);
    } catch (error) {
      console.error("Erro ao gerar parcelas:", error.message);
    }
  }

  const aplicarAtrasoSeHouver = (content) => {
    const liquidado = !!content?.liquidado;
    const dataReferencia = content?.dataVencto || content?.dataPrevisao;

    if (!liquidado && dataReferencia) {
      const dias = diffDias(dataReferencia) || 0;

      if (dias > 0) {
        setAtraso(dias);
        setIsVencido(true);
        return dias;
      }
    }

    setAtraso("");
    setIsVencido(false);
    return 0;
  };

  const handleLiquidar = () => {
    const required = (cond, msg) => {
      if (cond) return false;
      setPayloadErrors([msg]);
      setOpenPayloadModal(true);
      return true;
    };

    const parseMoneyPtBr = (v) => {
      if (v == null) return 0;
      const s = String(v).trim();
      if (!s) return 0;

      const cleaned = s.replace(/[^\d.,-]/g, "");

      const normalized = cleaned.includes(",")
        ? cleaned.replace(/\./g, "").replace(",", ".")
        : cleaned;

      const n = Number(normalized);
      return Number.isFinite(n) ? n : 0;
    };

    const requiredValorMaiorQueZero = (value, msg) => {
      const n = parseMoneyPtBr(value);
      if (n > 0) return false;
      setPayloadErrors([msg]);
      setOpenPayloadModal(true);
      return true;
    };

    if (required(!!fornecedor.trim(), "Fornecedor deve ser preenchido."))
      return;
    if (required(!!tipoDoc.trim(), "Tipo documento deve ser preenchido."))
      return;
    if (
      required(!!estabelecimento.trim(), "Estabelecimento deve ser preenchida.")
    )
      return;
    if (required(!!centroCusto.trim(), "Centro de custo deve ser preenchido."))
      return;
    if (required(!!despesa.trim(), "Despesa deve ser preenchida.")) return;
    if (required(!!contaContabil.trim(), "Conta contábil deve ser preenchida."))
      return;
    if (
      required(!!breveDescricao.trim(), "Breve descrição deve ser preenchida.")
    )
      return;

    if (dataEmissao > dataVencto) {
      setPayloadErrors([
        "Data vencimento deve ser maior ou igual a data de emissão.",
      ]);
      setOpenPayloadModal(true);
      return;
    }

    if (dataPrevisao < dataVencto) {
      setPayloadErrors([
        "Data previsão deve ser maior ou igual a data de vencimento.",
      ]);
      setOpenPayloadModal(true);
      return;
    }

    if (required(!!dataEmissao.trim(), "Data emissão deve ser preenchida."))
      return;
    if (required(!!dataVencto.trim(), "Data vencimento deve ser preenchida."))
      return;
    if (required(!!dataPrevisao.trim(), "Data previsão deve ser preenchida."))
      return;

    if (required(!!valorValores.trim(), "Valor deve ser preenchido.")) return;
    if (
      requiredValorMaiorQueZero(valorValores, "Valor deve ser maior que zero.")
    )
      return;

    if (required(!!parcela.trim(), "Parcela deve ser preenchida.")) return;

    const valorNumerico = parseFloat(
      valorCorrigido.toString().replace(/\./g, "").replace(",", "."),
    );

    if (isNaN(valorNumerico) || valorNumerico <= 0) {
      setPayloadErrors(["Valor corrigido deve ser maior que zero."]);
      setOpenPayloadModal(true);
      return;
    }

    setOpenLiquidacao(true);
  };

  const handleConfirmEstorno = async () => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const [ano, mes, dia] = dataVencto.split("-").map(Number);
    const vencimento = new Date(ano, mes - 1, dia);

    const isRealmenteAtrasado = vencimento < hoje;

    const novaSituacaoId = isRealmenteAtrasado ? "3" : "2";
    const novaSituacaoTexto = isRealmenteAtrasado ? "Atrasado" : "A Pagar";

    const payload = {
      id,
      liquidado: false,
      situacao: novaSituacaoTexto,
      situacaoId: novaSituacaoId,
      data: "",
      valorPagamento: "",
    };
    try {
      await axios.post(
        `${API_URL}/contasapagar/liquidacao`,
        payload,
        headers(),
      );

      setSituacaoId(novaSituacaoId);
      setSituacao(novaSituacaoTexto);

      setData("");
      setValorPagamento("");
      setOpenConfirmEstorno(false);
      setIsEstornado(true);
      setIsLiquidado(false);

      aplicarAtrasoSeHouver({
        liquidado: false,
        dataVencto,
        dataPrevisao,
      });
    } catch (error) {
      console.error("Erro ao estornar:", error);
      errorHandler(error);
    }
  };

  const handleEstornar = () => {
    setOpenConfirmEstorno(true);
  };

  const newLancamento = () => {
    setSituacaoId("");
    setSituacao("A Pagar");
    const hoje = new Date();
    const yyyy = hoje.getFullYear();
    const mm = String(hoje.getMonth() + 1).padStart(2, "0");
    const dd = String(hoje.getDate()).padStart(2, "0");
    setInativo(false);
    setIsEditing(false);
    setDataEmissao(`${yyyy}-${mm}-${dd}`);
    setCompetencia(`${mm}/${yyyy}`);
    setLoading(false);
    setNotFound(false);
    setShowGrid(false);
    setIsSearch(false);
    setIsMultiLanc(false);
  };

  const handleChangeCentroCusto = async (e) => {
    const centroCustoId = e.target.value;
    setCentroCusto(centroCustoId);

    try {
      const response = await axios.get(
        `${API_URL}/despesa/combo?centroCustoId=${centroCustoId}`,
        headers(),
      );

      const listaFiltrada = (response.data.despesa || []).filter(
        (item) => !item.inativo,
      );
      setDespesaList(listaFiltrada);
    } catch (error) {
      errorHandler(error);
      setDespesaList([]);
    }
  };

  const handleChangeDespesa = async (e) => {
    const despesaId = e.target.value;
    setDespesa(despesaId);

    try {
      const response = await axios.get(
        `${API_URL}/centrocusto/combo?despesaId=${despesaId}`,
        headers(),
      );

      const listaFiltrada = (response.data.centrocusto || []).filter(
        (item) => !item.inativo,
      );
      setCentroCustoList(listaFiltrada);
    } catch (error) {
      errorHandler(error);
      setCentroCustoList([]);
    }
  };

  const cadLancamento = () => {
    // console.log(valorCorrigido);
    const required = (cond, msg) => {
      if (cond) return false;
      setPayloadErrors([msg]);
      setOpenPayloadModal(true);
      return true;
    };

    const parseMoneyPtBr = (v) => {
      if (v == null) return 0;
      const s = String(v).trim();
      if (!s) return 0;

      const cleaned = s.replace(/[^\d.,-]/g, "");

      const normalized = cleaned.includes(",")
        ? cleaned.replace(/\./g, "").replace(",", ".")
        : cleaned;

      const n = Number(normalized);
      return Number.isFinite(n) ? n : 0;
    };

    const requiredValorMaiorQueZero = (value, msg) => {
      const n = parseMoneyPtBr(value);
      if (n > 0) return false;
      setPayloadErrors([msg]);
      setOpenPayloadModal(true);
      return true;
    };

    if (required(!!fornecedor.trim(), "Fornecedor deve ser preenchido."))
      return;
    if (required(!!tipoDoc.trim(), "Tipo documento deve ser preenchido."))
      return;
    if (
      required(!!estabelecimento.trim(), "Estabelecimento deve ser preenchida.")
    )
      return;
    if (required(!!centroCusto.trim(), "Centro de custo deve ser preenchido."))
      return;
    if (required(!!despesa.trim(), "Despesa deve ser preenchida.")) return;
    if (required(!!contaContabil.trim(), "Conta contábil deve ser preenchida."))
      return;
    if (
      required(!!breveDescricao.trim(), "Breve descrição deve ser preenchida.")
    )
      return;

    if (dataEmissao > dataVencto) {
      setPayloadErrors([
        "Data vencimento deve ser maior ou igual a data de emissão.",
      ]);
      setOpenPayloadModal(true);
      return;
    }

    if (dataPrevisao < dataVencto) {
      setPayloadErrors([
        "Data previsão deve ser maior ou igual a data de vencimento.",
      ]);
      setOpenPayloadModal(true);
      return;
    }

    if (isMultiLanc) {
      if (required(!!emissao.trim(), "Data emissão deve ser preenchida."))
        return;
      if (
        required(
          !!venctoInicial.trim(),
          "Vencimento inicial deve ser preenchido.",
        )
      )
        return;

      if (required(!!valorMulti.trim(), "Valor deve ser preenchido.")) return;
      if (
        requiredValorMaiorQueZero(valorMulti, "Valor deve ser maior que zero.")
      )
        return;

      if (required(!!parcela.trim(), "Parcelas deve ser preenchida.")) return;

      if (!Array.isArray(parcelasGeradas) || parcelasGeradas.length === 0) {
        setPayloadErrors(["Gere as parcelas antes de salvar."]);
        setOpenPayloadModal(true);
        return;
      }

      if (venctoInicial < emissao) {
        setPayloadErrors([
          "Vencimento inicial deve ser maior que a data de emissão.",
        ]);
        setOpenPayloadModal(true);
        return;
      }
    } else {
      if (required(!!dataEmissao.trim(), "Data emissão deve ser preenchida."))
        return;
      if (required(!!dataVencto.trim(), "Data vencimento deve ser preenchida."))
        return;
      if (required(!!dataPrevisao.trim(), "Data previsão deve ser preenchida."))
        return;

      if (required(!!valorValores.trim(), "Valor deve ser preenchido.")) return;
      if (
        requiredValorMaiorQueZero(
          valorValores,
          "Valor deve ser maior que zero.",
        )
      )
        return;

      if (required(!!parcela.trim(), "Parcela deve ser preenchida.")) return;
      const valorNumerico = parseFloat(
        valorCorrigido.toString().replace(/\./g, "").replace(",", "."),
      );

      if (isNaN(valorNumerico) || valorNumerico <= 0) {
        setPayloadErrors(["Valor corrigido deve ser maior que zero."]);
        setOpenPayloadModal(true);
        return;
      }
    }

    setOpenConfirmModal(true);
  };

  const gerarGrupoTitulo = () => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    const rnd = Math.random().toString(36).slice(2, 6).toUpperCase();
    return `${yyyy}${mm}${dd}${hh}${mi}${ss}-${rnd}`;
  };

  const isAtrasado = (dtStr) => {
    if (!dtStr) return false;

    const onlyDate = String(dtStr).slice(0, 10);

    const [y, m, d] = onlyDate.split("-").map(Number);
    const vencto = new Date(y, m - 1, d);

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    return vencto < hoje;
  };

  const salvarMultiParcelas = async (basePayload) => {
    let numTituloGrupo = "";

    for (const p of parcelasGeradas) {
      const atrasado = isAtrasado(p.vencimento);

      const [ano, mes] = p.vencimento.split("-");
      const competenciaGerada = `${mes}/${ano}`;

      const payload = {
        ...basePayload,
        ...(numTituloGrupo ? { numTitulo: numTituloGrupo } : {}),
        parcela: String(p.parcela),
        dataEmissao: emissao,
        dataVencto: p.vencimento,
        dataPrevisao: p.vencimento,
        valorValores: p.valor.replace("R$", "").trim(),
        isMultiLanc: true,
        liquidado: false,
        competencia: competenciaGerada,
      };

      console.log(payload);

      const r = await axios.post(`${API_URL}/contasapagar`, payload, headers());
      numTituloGrupo = numTituloGrupo || r.data.numTitulo;
    }

    handleBack();
    setNumTitulo(numTituloGrupo);
    setIsEditing(false);
    setIsSearch(true);
    setIsMultiLanc(false);
  };

  const handleConfirmSave = async () => {
    setOpenConfirmModal(false);

    const atrasadoBase = isAtrasado(dataVencto);
    let situacaoFinal = "";
    let situacaoIdFinal = "";

    if (situacaoId === "4") {
      situacaoFinal = "Cancelado";
      situacaoIdFinal = "4";
    } else if (isLiquidado) {
      situacaoFinal = "Pago";
      situacaoIdFinal = "1";
    } else if (atrasadoBase) {
      situacaoFinal = "Atrasado";
      situacaoIdFinal = "3";
    } else {
      situacaoFinal = "A Pagar";
      situacaoIdFinal = "2";
    }

    const basePayload = {
      name: fornecedorList?.find((f) => f.id === fornecedor)?.name || "",
      inativo,
      fornecedorId: fornecedor,
      tipoDocId: tipoDoc,
      estabelecimentoId: estabelecimento,
      numDoc: numDoc.trim(),
      agenteCobradorId: agenteCobrador,
      centroCustoId: centroCusto,
      despesaId: despesa,
      contaContabilId: contaContabil,
      breveDescricao: breveDescricao.trim(),
      historico: historico.trim(),
      atraso,
      data,
      competencia,
      valorPagamento: valorPagamento.replace("R$", "").trim(),
      valorJurosDia: valorJurosDia.replace("R$", "").trim(),
      multa,
      acerto,
      tipoFormaPagamento,
      descricao,
      dataConciliacao,
      valorFormaPagamento,
      banco,
      agencia,
      conta,
      numCheque,
      situacao: situacaoFinal,
      situacaoId: situacaoIdFinal,
      formasPagamento: formasPagamento,
    };

    if (isMultiLanc) {
      await salvarMultiParcelas(basePayload);
      setIsEditing(true);
      return;
    }

    const payload = {
      ...basePayload,
      id: isEditing ? id : undefined,
      numTitulo,
      parcela: parcela.trim(),
      dataEmissao,
      dataVencto,
      dataPrevisao,
      valorValores: valorValores.replace("R$", "").trim(),
      liquidado: isLiquidado ? true : false,
      isMultiLanc: false,
    };

    try {
      const response = await axios.post(
        `${API_URL}/contasapagar`,
        payload,
        headers(),
      );

      // console.log(response.data);
      setId(response.data.id);
      // console.log(situacaoId);
      setNumTitulo(response.data.numTitulo);
      setIsEditing(true);
      setSituacao(situacaoFinal);
      setSituacaoId(situacaoIdFinal);
    } catch (error) {
      console.error("Erro ao salvar lancamento:", error);
      errorHandler(error);
    }
  };

  const newMultiLanc = () => {
    setSituacaoId("");
    setSituacao("A Pagar");
    setInativo(false);
    setLoading(false);
    setIsEditing(false);
    setNotFound(false);
    setShowGrid(false);
    setIsSearch(false);
    setIsMultiLanc(true);
  };

  const handleBack = () => {
    clearFields();
    setIsLiquidado(false);
    setHasSearched(false);
    setLoading(false);
    setNotFound(false);
    setShowGrid(false);
    setIsSearch(true);
    setIsMultiLanc(false);
    setSearchValue("");
    setParcelasGeradas([]);
    setValorMulti("");
    setVenctoInicial("");
    setPrazo("");
    setDiaEspecifico("");
    setTipoFormaPagamento("");
    setDescricao("");
    setDataConciliacao("");
    setValorFormaPagamento("");
    setBanco("");
    setAgencia("");
    setConta("");
    setNumCheque("");
    setTipoTit("");
    setEmissao("");
  };

  const clearFields = () => {
    setFornecedor("");
    setTipoDoc("");
    // setDataInicio("");
    setSituacaoAberto(false);
    setSituacaoPago(false);
    setSituacaoCancelado(false);
    // setDataFim("");
    setAntecipaFeriado(false);
    setAntecipaFimSemana(false);
    setEstabelecimento("");
    setSituacao("");
    setNumTitulo("");
    setParcela("");
    setNumDoc("");
    setAgenteCobrador("");
    setCentroCusto("");
    setDespesa("");
    setContaContabil("");
    setBreveDescricao("");
    setHistorico("");
    setDataEmissao("");
    setDataVencto("");
    setDataPrevisao("");
    setAtraso("");
    setIsVencido(false);
    setData("");
    setCompetencia("");
    setValorPagamento("");
    setValorValores("");
    setValorJurosDia("");
    setMulta("");
    setAcerto("");
    setValorCorrigido("");
  };

  return (
    <>
      <Grid wrap="wrap">
        <Grid
          size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Breadcrumbs
              separator={<NavigateNext fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Typography
                className={css(styles.pageTitle)}
                sx={{ fontWeight: 400, color: "#828282" }}
              >
                Contas a Pagar
              </Typography>
              <Typography className={css(styles.pageTitle)}>
                Lançamentos
              </Typography>
              {isMultiLanc && (
                <Typography className={css(styles.pageTitle)}>
                  Múltiplas parcelas
                </Typography>
              )}
            </Breadcrumbs>
          </div>
          {isSearch && (
            <Box sx={{ display: "flex", gap: "5px" }}>
              <button
                onClick={newLancamento}
                className={css(styles.topBtn)}
                title="Inclui"
              >
                <PostAdd />
              </button>
              <button
                onClick={newMultiLanc}
                className={css(styles.topBtn)}
                title="Múltiplas parcelas"
              >
                <DynamicFeed />
              </button>
            </Box>
          )}
          {!isSearch && (
            <button
              onClick={handleBack}
              className={css(styles.topBtn)}
              title="Voltar"
            >
              <ArrowBack style={{ fontSize: "1.4rem" }} />
            </button>
          )}
        </Grid>
      </Grid>

      <hr
        style={{
          color: "#eee",
          marginBottom: "0.75rem",
        }}
      />

      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <FilterContasAPagarLanc
          fornecedorListAtivos={fornecedorListAtivos}
          tipoDocListAtivos={tipoDocListAtivos}
          estabelecimentoListAtivos={estabelecimentoListAtivos}
          agenteCobradorListAtivos={agenteCobradorListAtivos}
          centroCustoListAtivos={centroCustoListAtivos}
          despesaListAtivos={despesaListAtivos}
          planoContasListAtivos={planoContasListAtivos}
          contaCorrenteListAtivos={contaCorrenteListAtivos}
          tipoFormaPagamentoListAtivos={tipoFormaPagamentoListAtivos}
          situacaoId={situacaoId}
          formasPagamento={formasPagamento}
          setFormas={setFormasPagamento}
          parcelasGeradas={parcelasGeradas}
          handleChangeCentroCusto={handleChangeCentroCusto}
          handleChangeDespesa={handleChangeDespesa}
          gerarParcelas={gerarParcelas}
          handleBack={handleBack}
          searchValue={searchValue}
          contaCorrenteList={contaCorrenteList}
          setSearchValue={setSearchValue}
          isSearch={isSearch}
          isMultiLanc={isMultiLanc}
          searchContasAPagar={searchContasAPagar}
          fornecedor={fornecedor}
          setFornecedor={setFornecedor}
          fornecedorList={fornecedorList}
          tipoDoc={tipoDoc}
          setTipoDoc={setTipoDoc}
          tipoDocList={tipoDocList}
          estabelecimento={estabelecimento}
          setEstabelecimento={setEstabelecimento}
          estabelecimentoList={estabelecimentoList}
          situacao={situacao}
          setSituacao={setSituacao}
          numTitulo={numTitulo}
          setNumTitulo={setNumTitulo}
          parcela={parcela}
          setParcela={setParcela}
          numDoc={numDoc}
          setNumDoc={setNumDoc}
          agenteCobrador={agenteCobrador}
          agenteCobradorList={agenteCobradorList}
          setAgenteCobrador={setAgenteCobrador}
          centroCusto={centroCusto}
          setCentroCusto={setCentroCusto}
          centroCustoList={centroCustoList}
          despesa={despesa}
          despesaList={despesaList}
          setDespesa={setDespesa}
          contaContabil={contaContabil}
          setContaContabil={setContaContabil}
          planoContasList={planoContasList}
          breveDescricao={breveDescricao}
          setBreveDescricao={setBreveDescricao}
          historico={historico}
          setHistorico={setHistorico}
          atraso={atraso}
          setAtraso={setAtraso}
          setIsVencido={setIsVencido}
          isVencido={isVencido}
          data={data}
          setData={setData}
          competencia={competencia}
          setCompetencia={setCompetencia}
          valorPagamento={valorPagamento}
          setValorPagamento={setValorPagamento}
          valorValores={valorValores}
          setValorValores={setValorValores}
          valorJurosDia={valorJurosDia}
          setValorJurosDia={setValorJurosDia}
          multa={multa}
          setMulta={setMulta}
          acerto={acerto}
          setAcerto={setAcerto}
          valorCorrigido={valorCorrigido}
          setValorCorrigido={setValorCorrigido}
          dataEmissao={dataEmissao}
          setDataEmissao={setDataEmissao}
          dataVencto={dataVencto}
          setDataVencto={setDataVencto}
          dataPrevisao={dataPrevisao}
          setDataPrevisao={setDataPrevisao}
          valorPagamento={valorPagamento}
          setValorPagamento={setValorPagamento}
          valorValores={valorValores}
          setValorValores={setValorValores}
          valorJurosDia={valorJurosDia}
          setValorJurosDia={setValorJurosDia}
          multa={multa}
          setMulta={setMulta}
          acerto={acerto}
          setAcerto={setAcerto}
          valorCorrigido={valorCorrigido}
          setValorCorrigido={setValorCorrigido}
          valorMulti={valorMulti}
          setValorMulti={setValorMulti}
          antecipaFeriado={antecipaFeriado}
          setAntecipaFeriado={setAntecipaFeriado}
          antecipaFimSemana={antecipaFimSemana}
          setAntecipaFimSemana={setAntecipaFimSemana}
          emissao={emissao}
          setEmissao={setEmissao}
          venctoInicial={venctoInicial}
          setVenctoInicial={setVenctoInicial}
          prazo={prazo}
          setPrazo={setPrazo}
          diaEspecifico={diaEspecifico}
          setDiaEspecifico={setDiaEspecifico}
          tipoFormaPagamento={tipoFormaPagamento}
          setTipoFormaPagamento={setTipoFormaPagamento}
          tipoFormaPagamentoList={tipoFormaPagamentoList}
          setTipoFormaPagamentoList={setTipoFormaPagamentoList}
          descricao={descricao}
          setDescricao={setDescricao}
          dataConciliacao={dataConciliacao}
          setDataConciliacao={setDataConciliacao}
          valorFormaPagamento={valorFormaPagamento}
          setValorFormaPagamento={setValorFormaPagamento}
          banco={banco}
          setBanco={setBanco}
          bancosList={bancosList}
          setBancosList={setBancosList}
          agencia={agencia}
          setAgencia={setAgencia}
          agenciasList={agenciasList}
          setAgenciasList={setAgenciasList}
          conta={conta}
          setConta={setConta}
          contasList={contasList}
          setContasList={setContasList}
          numCheque={numCheque}
          setNumCheque={setNumCheque}
          tipoTit={tipoTit}
          setTipoTit={setTipoTit}
          tipoTitList={tipoTitList}
          setTipoTitList={setTipoTitList}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          cadLancamento={cadLancamento}
          isEstornado={isEstornado}
          setIsEstornado={setIsEstornado}
          isLiquidado={isLiquidado}
          setIsLiquidado={setIsLiquidado}
          handleLiquidar={handleLiquidar}
          handleEstornar={handleEstornar}
          dataInicio={dataInicio}
          setDataInicio={setDataInicio}
          dataFim={dataFim}
          setDataFim={setDataFim}
          situacaoAberto={situacaoAberto}
          setSituacaoAberto={setSituacaoAberto}
          situacaoCancelado={situacaoCancelado}
          setSituacaoCancelado={setSituacaoCancelado}
          situacaoPago={situacaoPago}
          setSituacaoPago={setSituacaoPago}
        />

        {isEditing && isLiquidado && (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              mt: 1,
            }}
          >
            <FormasPagamentoTable
              textFieldStyles={textFieldStyles}
              formatNumber={formatNumber}
              tipoFormaPagamentoList={tipoFormaPagamentoList}
              bancosList={contaCorrenteList}
              value={formasPagamento}
              onChange={setFormasPagamento}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
            />
          </Box>
        )}

        {showGrid ? (
          <>
            <Box
              sx={{
                width: "100%",
                display: "grid",
              }}
            >
              <CustomDatagrid
                head={head}
                row={rows}
                totals={totals}
                loading={loading}
                // onEyeClick={(row) => console.log("ver", row)}
                onEditClick={(row) => handleEdit(row)}
                columnOverrides={{
                  id: { maxWidth: 150 },
                  name: { minWidth: 250 },
                  dataVencto: { maxWidth: 200 },
                  statusLiquidado: { maxWidth: 200 },
                  valorValores: { minWidth: 180 },
                }}
                onCloneClick={(row) => handleClone(row)}
                // hasTotal={true}
                onDeleteClick={(row) => handleDelete(row)}
              />
            </Box>
            {totalPages > 1 && (
              <Pagination
                page={page}
                count={totalPages}
                showFirstButton
                showLastButton
                sx={{
                  mt: 1,
                  "& .MuiPaginationItem-root.Mui-selected": {
                    background: Colors.mainLayoutAtiveBackground,
                    color: "black",
                  },
                }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    component={Link}
                    to={`/contas-a-pagar/lancamento${
                      item.page
                        ? `?page=${item.page}${filter ? `&filtro=${filter}` : ""}`
                        : ""
                    }`}
                  />
                )}
              />
            )}
          </>
        ) : null}

        {loading ? (
          <Box
            width={"100%"}
            height={"45vh"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              xs={12}
              md={12}
              textAlign={"center"}
              justifyContent={"center"}
              alignItems={"center"}
              bgcolor={"#cadccaff"}
              borderRadius={5}
              padding={5}
              color={Colors.noResultFont}
            >
              <div display={"flex"} style={{ marginTop: "-0.5rem" }}>
                <CircularProgress color="success" />
              </div>
              <div display={"flex"}>
                <p
                  style={{
                    color: "#4b4b4b",
                    fontSize: 14,
                    marginBottom: "-1rem",
                  }}
                >
                  {titleLoading}
                </p>
              </div>
            </Grid>
          </Box>
        ) : null}
        {notFound ? (
          <Box
            width={"100%"}
            height={"45vh"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              height={{ md: "20%", xs: "50%" }}
              display={"inline-flex"}
              textAlign={"center"}
              justifyContent={"center"}
              alignItems={"center"}
              bgcolor={"lightyellow"}
              borderRadius={5}
              padding={5}
              color={Colors.noResultFont}
            >
              <p
                style={{
                  color: "#4b4b4b",
                  fontSize: 14,
                }}
              >
                Sua pesquisa não retornou nenhum resultado.
              </p>
            </Grid>
          </Box>
        ) : null}

        <ErrorModal
          open={openPayloadModal}
          onClose={() => setOpenPayloadModal(false)}
          errors={payloadErrors}
        />

        <ConfirmModal
          open={openConfirmModal}
          onClose={() => setOpenConfirmModal(false)}
          onConfirm={handleConfirmSave}
          title="Lançamento de contas"
          message="Deseja realmente lançar este pagamento?"
        />

        <ConfirmModal
          open={openConfirmEstorno}
          onClose={() => setOpenConfirmEstorno(false)}
          onConfirm={handleConfirmEstorno}
          title="Estorno"
          message="Deseja realmente estornar este pagamento?"
        />

        <ConfirmModal
          open={openMessageModal}
          onClose={() => setOpenMessageModal(false)}
          onConfirm={handleConfirmDelete}
          message={messageModal}
        />

        <LiquidacaoModal
          setSituacaoId={setSituacaoId}
          setValorCorrigido={setValorCorrigido}
          open={openLiquidacao}
          setData={setData}
          onClose={() => setOpenLiquidacao(false)}
          onConfirm={(payload) => console.log(payload)}
          setIsLiquidado={setIsLiquidado}
          setValorPagamento={setValorPagamento}
          setIsEstornado={setIsEstornado}
          setSituacao={setSituacao}
          setFormas={setFormasPagamento}
          setAtraso={setAtraso}
          setIsVencido={setIsVencido}
          isVencido={isVencido}
          dados={{
            id: id,
            fornecedorNome:
              fornecedorList?.find((f) => f.id === fornecedor)?.name ||
              "Não encontrado",
            fornecedorId: fornecedor,
            numTitulo,
            parcela,
            numDocumento: numDoc,
            dataEmissao,
            dataVencto,
            dataPrevisao,
            dataPagto: dataVencto,
            atrasoDias: atraso,
            breveDescricao,
            valor: valorValores,
            jurosDia: valorJurosDia,
            multaPerc: multa,
            acerto,
            valorCorrigido,
          }}
          tipoFormaPagamentoList={tipoFormaPagamentoList}
          tipoFormaPagamentoListAtivos={tipoFormaPagamentoListAtivos}
          bancosList={contaCorrenteList}
          agenciasList={contaCorrenteList}
          contasList={contaCorrenteList}
        />
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
    fontSize: 14,
    margin: 0,
  },
  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 1.5,
  },

  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
    textDecoration: "none",
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 4,
    marginTop: "-0.5rem",
    cursor: "pointer",

    padding: "5px 8px 3px 8px",
    transitionDuration: "0.2s",

    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  topBtn: {
    backgroundColor: "#669966",
    cursor: "pointer",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: "4px 8px",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
    "@media (max-width: 375px)": {
      fontSize: 10,
      padding: "0.3rem 0.5rem",
    },
  },
});
